export const themeConfig = {
    token: {
      colorPrimary: '#3b82f6',
      borderRadius: 12,
      colorBgContainer: '#ffffff',
      colorBgLayout: '#f8fafc',
      colorBgElevated: '#ffffff',
      colorBorder: '#e2e8f0',
      colorBorderSecondary: '#f1f5f9',
      colorText: '#1e293b',
      colorTextHeading: '#0f172a',
      colorTextSecondary: '#64748b',
      colorFillSecondary: '#f1f5f9',
    },
    components: {
      Layout: {
        headerBg: '#ffffff',
        bodyBg: '#f8fafc',
        siderBg: '#ffffff',
      },
      Menu: {
        itemHoverBg: 'rgba(59, 130, 246, 0.08)',
        itemSelectedBg: 'rgba(59, 130, 246, 0.1)',
        itemSelectedColor: '#3b82f6',
        itemHoverColor: '#3b82f6',
        transition: 'all 0.3s',
      },
      Card: {
        colorBgContainer: '#ffffff',
        colorBorderSecondary: '#f1f5f9',
      },
      Button: {
        colorBgContainer: '#ffffff',
        defaultBorderColor: '#e2e8f0',
      },
      Dropdown: {
        colorBgElevated: '#ffffff',
      },
    },
  };